
<template>
    <div class="my-10">
        <NewsBanner v-if="bannerAds.length > 0" :content="bannerAds"></NewsBanner>
        <div class="flex justify-between my-5">
            <h1 class="text-2xl font-bold">
                {{ $t('nav.news') }}
            </h1>
            <div class="flex gap-5 items-center">
                <button @click="toggleFilter(true)" class="hidden gap-2 items-center text-main-color bg-white p-2 rounded-lg max-lg:flex"><IconFilter/><p>{{ $t('page.filter') }}</p></button>
            </div>
        </div>
        <div class="grid grid-cols-4 gap-5">
            <div class="col-span-1">
                <MediaSide 
                @closeFilter="toggleFilter(false)"
                :filterState="filterState"
                :categories="$store?.mediaCategories" 
                routeName="news" 
                :currentCategory="currentCategory" 
                :location="getLocation.id"
                :hideFilters="['isVip', 'currentSubscription']"></MediaSide>
            </div>
            <div class="col-span-3 max-lg:col-span-4">
                <div class="grid grid-cols-3 gap-4 max-lg:grid-cols-2">
                    <template v-if="news.length > 0">
                        <router-link v-for="item in news" :key="item?.id" :to="{ name: 'newsDetail', params: { id: item?.id } }">
                            <NewsCard class="w-full" :detail="item">
                            </NewsCard>
                        </router-link>
                    </template>
                    <div v-show="news.length === 0 && loading === false">
                        <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.not_found') }}</p>
                    </div>

                </div>
                <div v-show="loading === true" class="flex justify-center mt-10" role="status">
                    <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
                    </IconSpinner>

                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import NewsCard from '@cmp/media/NewsCard.vue'
import NewsBanner from '@cmp/NewsBanner.vue'
import MediaSide from '@cmp/media/MediaSide.vue'
import IconFilter from '@icons/IconFilter.vue';
import IconSpinner from '@icons/IconSpinner.vue';
import api from '@/api';
import { updateLastSeen } from '@/helpers'
export default {
    name: 'news',
    components: {
        NewsCard,
        MediaSide,
        IconSpinner,
        IconFilter,
        NewsBanner
    },
    watch: {
        '$route.query.category': {
            //   immediate: true,
            async handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.currentCategory = newValue
                    this.news = []
                    await this.getNews()
                }
             
            },
        },
       
    },
    data() {
        return {
            loading: false,
            news: [],
            currentCategory: null,
            currentSubscription: null,
            page: 1,
            count: 0,
            next: null,
            filterState: false,
            bannerAds: []
        }
    },
    methods: {
        toggleFilter(e){
            this.filterState = e
            document.body.style.overflowY = e ? 'hidden' : 'initial'
        },
        infiniteScroll() {
            let scrollTop = document.documentElement.scrollTop
            let scrollHeight = document.documentElement.scrollHeight
            let clientHeight = document.documentElement.clientHeight
            if (scrollTop + clientHeight >= scrollHeight - 650) {
                if (this.next !== null && this.loading === false) {
                    this.page += 1
                    this.getNews()
                }
            }
        },
         async getNews() {
            this.loading = true
            try {
                const response = await api.get('posts/announcements/', { params: { category: this.currentCategory, page: this.page, location: this.getLocation.id } })
                const results = response.data.results
                results.forEach(element => {
                    this.news.push(element)
                });
                this.count = response.data.count
                this.next = response.data.next
            } catch (e) {
                console.log(e)
            }
            this.loading = false

        },
         async getNewsBanner() {
            this.loading = true
            try {
                const response = await api.get('posts/announcements/', { params: { is_banner: true, page: this.page, location: this.getLocation.id } })
                this.bannerAds = response.data.results
            } catch (e) {
                console.log(e)
            }
            this.loading = false

        },
    },
    computed: {
        getLocation(){
            return JSON.parse(localStorage.getItem('selectedLocation')) || 1
        }
    },
    mounted() {
        window.addEventListener("scroll", this.infiniteScroll)
    },
    unmounted() {
        window.removeEventListener("scroll", this.infiniteScroll)
    },
    async created() {
        this.currentCategory = this.$route.query.category
        await this.getNewsBanner()
        await this.getNews()
        updateLastSeen('announcements')
    }
}

</script>

<style scoped></style>
